import React from "react";
import { getAlertColors } from "../Alert/helpers";
import { TAlertColor } from "../Alert/types";
import * as S from "./styled";

export interface IBannerProps extends React.ComponentProps<typeof S.Banner> {
    color?: TAlertColor;
    noShadow?: boolean;
    children?: React.ReactNode;
    border?: boolean;

    /** @deprecated */
    textList?: string[];
}

const Banner: React.FC<IBannerProps> = ({ textList, color = "heads-up", noShadow = true, children, ...props }) => {
    const colors = getAlertColors(color);

    return (
        <S.Banner
            $textColor={colors.textColor}
            $backgroundColor={colors.backgroundColor}
            $borderColor={colors.borderColor}
            $noShadow={noShadow}
            {...props}
        >
            {!children && textList && (
                <ul>
                    {textList.map(text => (
                        <li key={text}>{text}</li>
                    ))}
                </ul>
            )}
            {children}
        </S.Banner>
    );
};

export default Banner;
